import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa';
import { Link as LinkS } from 'react-scroll';
import { motion } from 'framer-motion';

export const SidebarContainer = styled(motion.aside)`
  position: fixed;
  z-index: 999;
  inset: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(5, 5, 5, 0.92);
  backdrop-filter: blur(16px);
  pointer-events: ${({ isOpen }) => (isOpen ? 'all' : 'none')};
`;

export const Icon = styled.div`
  position: absolute;
  top: 1.6rem;
  right: 1.8rem;
  cursor: pointer;
  outline: none;
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => props.theme.text};
  }
`;

export const CloseIcon = styled(FaTimes)`
  color: #fff;
  font-size: 1.5rem;
`;

export const SidebarWrapper = styled.div`
  color: #fff;
  width: 100%;
`;

export const SidebarMenu = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  list-style: none;
`;

export const SidebarBtnWrap = styled(motion.li)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SidebarLink = styled(LinkS)`
  color: #e9edf5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 28px;
  font-size: 1.5rem;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  border-radius: 14px;
  transition: color 0.2s ease, background 0.2s ease, transform 0.2s ease;

  &:hover {
    color: ${(props) => props.theme.text};
    background: ${(props) => props.theme.text}1c;
    transform: translateY(-2px);
  }
`;
